import { StripeCardElementOptions } from "@stripe/stripe-js";

import colors from "@app/styles/_colors.module.scss";

export const CARD_OPTIONS: StripeCardElementOptions = {
  iconStyle: "solid",
  style: {
    base: {
      ":-webkit-autofill": { color: colors.yellow050 },
      "::placeholder": { color: colors.primary025 },
      color: colors.white,
      fontFamily: "Roboto, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      fontWeight: 500,
      iconColor: colors.primary025,
    },
    invalid: {
      color: colors.red025,
      iconColor: colors.red025,
    },
  },
};
